import { APP_DATE_FORMAT_EXPANDED } from "@/config/constants";
import { IEdoQuizAttempt } from "@/shared/model/edo-quiz-attempt.model";
import { getQuizAttemptStatus } from "@/shared/util/quiz-utils";
import { ListItem } from "@/components/ui";
import axios from "axios";
import { useEffect, useState } from "react";
import { TextFormat } from "react-jhipster";

interface AttemptRowProps {
  quizAttempt: IEdoQuizAttempt;
  onOpen: (quizAttempt: IEdoQuizAttempt) => void;
}

const AttemptRow = (props: AttemptRowProps) => {
  const [score, setScore] = useState<{ score: number; totalScore: number }>({
    score: 0,
    totalScore: 0,
  });
  const { quizAttempt, onOpen: handleOpen } = props;

  const getQuizAttemptScore = async () => {
    const response = await axios.get<{
      data: { score: number; totalScore: number };
    }>(`/quiz-attempts/${quizAttempt?.id}/score`);
    setScore(response.data.data);
  };

  useEffect(() => {
    if (quizAttempt?.id) getQuizAttemptScore();
  }, [quizAttempt?.id]);

  return (
    <ListItem
      className="cursor-pointer pl-4"
      onClick={() => handleOpen(quizAttempt)}
    >
      <div className="min-w-0 flex-1 overflow-hidden text-ellipsis">
        <p className="text-body font-medium text-[var(--color-mockup-text)]">
          Tentativo consegnato il{" "}
          <TextFormat
            value={quizAttempt.timeFinish}
            type="date"
            format={APP_DATE_FORMAT_EXPANDED}
          />
        </p>
        <p className="text-body-sm text-[var(--color-mockup-text-light)]">
          {getQuizAttemptStatus(quizAttempt, score.score, score.totalScore)}
        </p>
      </div>
    </ListItem>
  );
};

export default AttemptRow;
